import BudgetPage from './BudgetPage';

export default BudgetPage;
